export const formatProjectDate = (dateString: string | number | Date) => {
  if (dateString === "N/A" || !dateString) {
    return "N/A";
  } else {
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? "N/A" : date.toISOString().split("T")[0];
  }
};
export const formatSubmittedDate = (dateString: string | number | Date) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "N/A";
  }

  // Use toLocaleDateString() for consistent formatting
  const [month, day, year] = date
    .toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/"); // US locale gives MM/DD/YYYY format

  // Rearrange to desired format
  return `${year}-${month}-${day}`;
};
export const formatSubmittedDateTime = (dateString: string | number | Date) => {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return "N/A";
  }

  // Use toLocaleDateString() for consistent formatting
  const [month, day, year] = date
    .toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/"); // US locale gives MM/DD/YYYY format

  const time = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false, // Ensures AM/PM format
  });

  // Rearrange to desired format
  return `${year}-${month}-${day} ${time}`;
};
